import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { NrrGrrReportContainer } from './containers/NrrGrrReportContainer';

const NRR_GRR_SUGGESTIONS = [
  "What's my current NRR?",
  "What's my current GRR?",
  'Show retention trend over the last 12 months',
  'Which customers contracted this month?',
  'Which customers expanded this month?',
];

const NrrGrrReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <Box
      sx={{
        transition: (theme) =>
          theme.transitions.create('margin-right', {
            easing: isOpen
              ? theme.transitions.easing.easeOut
              : theme.transitions.easing.sharp,
            duration: isOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
          }),
        marginRight: isOpen ? `${drawerWidth}px` : 0,
      }}
    >
      <VyLayout>
        <NrrGrrReportContainer />
      </VyLayout>
    </Box>
  );
};

const NrrGrrReportPage: React.FC = () => {
  const { setSuggestions } = useAiCopilot();

  useEffect(() => {
    setSuggestions(NRR_GRR_SUGGESTIONS);
    return () => setSuggestions(undefined);
  }, [setSuggestions]);

  return (
    <>
      <Helmet>
        <title>NRR / GRR Report</title>
      </Helmet>
      <NrrGrrReportLayout />
    </>
  );
};

const NrrGrrReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(NrrGrrReportPage),
);

export { NrrGrrReportPageWithSuspenseBoundary as NrrGrrReportPage };
